import { ShoppingCart, User, Menu } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "./ui/Button";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/Avatar";
import { Badge } from "./ui/Badge";
import { useCart } from "./CartContext";

interface HeaderProps {
  onNavigate?: (page: string) => void;
  user?: any;
  onOpenMobileMenu?: () => void;
}

export function Header({ user, onOpenMobileMenu }: HeaderProps) {
  const { totalItems, openCart } = useCart();

  return (
    <header className="border-b bg-white px-4 lg:px-6 py-4">
      <div className="flex items-center justify-between">
        {/* Mobile Menu Button */}
        <Button
          variant="ghost"
          size="icon"
          className="lg:hidden text-[#68686A]"
          onClick={onOpenMobileMenu}
        >
          <Menu className="h-6 w-6" />
        </Button>

        <div className="flex items-center space-x-4 ml-auto">
          <Button
            variant="ghost"
            size="icon"
            className="relative text-[#68686A] hover:bg-[#EEF1F2] hover:text-[#D4C070]"
            onClick={openCart}
          >
            <ShoppingCart className="h-5 w-5" />
            {totalItems > 0 && (
              <Badge className="absolute -top-1 -right-1 min-w-[20px] h-[20px] px-1 flex items-center justify-center text-xs bg-[#C2452D] hover:bg-[#C2452D] text-white border-2 border-white rounded-full leading-none">
                {totalItems}
              </Badge>
            )}
          </Button>

          <Link
            to="/perfil"
            className="flex items-center space-x-2 cursor-pointer hover:opacity-80 transition-opacity"
          >
            <span className="text-sm font-medium text-[#68686A] hidden sm:inline">
              {user?.name || user?.email}
            </span>
            <Avatar className="h-8 w-8">
              <AvatarImage src="/placeholder-avatar.jpg" />
              <AvatarFallback className="bg-[#D4C070] text-white">
                <User className="h-4 w-4" />
              </AvatarFallback>
            </Avatar>
          </Link>
        </div>
      </div>
    </header>
  );
}